import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/styled-engine';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
// import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import {store} from "./app/redux/store"
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <GoogleOAuthProvider clientId="428640965671-6pl2uk52kl7iaraka2mk96qnknspgl7a.apps.googleusercontent.com">
  <StyledEngineProvider injectFirst>
  <BrowserRouter>
    <CssBaseline />
    <Provider store={store}>
    <App />
    </Provider>
  </BrowserRouter>
</StyledEngineProvider>
</GoogleOAuthProvider>,
);



